import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { LocationService } from './location.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private locationService: LocationService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getToken();
    
    // Excluir el endpoint de mailer del interceptor de autenticación
    const isMailerEndpoint = request.url.includes('/mailer/send');
    
    if (token && !isMailerEndpoint) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Si recibimos un 401 Unauthorized en endpoints que requieren auth, limpiamos las credenciales
        if (error.status === 401 && !isMailerEndpoint) {
          // Solo redirigir si estamos en una ruta protegida
          const currentUrl = this.locationService.getPathname();
          const isProtectedRoute = currentUrl.startsWith('/dashboard');
          this.authService.logout(isProtectedRoute);
        }
        return throwError(() => error);
      })
    );
  }
}